<template>
  <div class="wrap" v-if="visible === 1">
    <template>
      <h1 class="common-header">{{ $t('524') }}</h1>
      <div class="by-content">
        <!-- 右侧列表 -->
        <div class="org-content">
          <div class="form-wrap">
            <el-input
              type="text"
              v-model="form.name"
              :placeholder="$t('829')"
              prefix-icon="el-icon-search"
              clearable
            ></el-input>
            <el-button type="primary" class="query" @click="handleGetAttendanceSettingList">{{ $t('80') }}</el-button>
            <el-button class="create-group-s" @click="visible = 4" v-if="$p('menu.work.clock.edit')">{{
              $t('830')
            }}</el-button>
            <el-button type="primary" class="create-group" @click="createGroup" v-if="$p('menu.work.clock.edit')">{{
              $t('543')
            }}</el-button>
          </div>
          <!-- 表格数据 -->
          <div class="table-wrap">
            <el-table :data="tableData" style="width: 100%" v-load="loading">
              <!-- 群组名称 -->
              <el-table-column prop="name" :label="$t('545')"></el-table-column>
              <!-- 类型 -->
              <el-table-column :label="$t('456')" prop="type_text"></el-table-column>
              <!-- 考勤时间 -->
              <el-table-column :label="$t('1363')" prop="shift">
                <template slot-scope="scope">
                  <p v-for="(item, index) in scope.row.shift" :key="index">{{ item }}</p>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column fixed="right" :label="$t('70')" width="180px">
                <template slot-scope="scope">
                  <!-- 排班  type等于4为排班-->
                  <el-button
                    type="text"
                    @click="handlerShe(scope.row, 3)"
                    v-if="scope.row.type === '4' && $p('menu.work.clock.edit')"
                    >{{ $t('1728') }}</el-button
                  >
                  <!-- 编辑 -->
                  <el-button type="text" @click="confirmAgree(scope.row)" v-if="$p('menu.work.clock.edit')">{{
                    $t('71')
                  }}</el-button>
                  <!-- 删除 -->
                  <el-button
                    type="text"
                    @click="handleDelSetting(scope.row)"
                    v-if="!(scope.row.is_default && scope.row.is_default == 1) && $p('menu.work.clock.delete')"
                    >{{ $t('65') }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="page-wrap">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagina.page"
                :page-sizes="[20, 40, 60, 100]"
                :page-size="pagina.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagina.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 公共假期 -->
    <!-- <common-holiday :visible.sync="holidayVisible" /> -->
  </div>
  <!-- 编辑群组 -->
  <Edit ref="edit" v-else-if="visible === 2" @doSubmit="handlerShe" :type="type" p="menu.work.frequency" />
  <!-- 公共假期设置 -->
  <common-holiday-rules v-else-if="visible === 4" @doSubmit="handlerShe" />
  <Scheduling v-else @doSubmit="open" ref="scheding" p="menu.work.frequency" />
</template>

<script>
import { getAttendanceSettingList, delSetting } from 'api/Attendance'
import Edit from './modal/edit-group'
import Scheduling from './modal/scheduling'
import commonHolidayRules from './modal/common-holiday-rules'
import { checkSettingRelation } from 'api/settings'
// import commonHoliday from '../modal/common-holiday'

export default {
  components: {
    Edit,
    // commonHoliday,
    Scheduling,
    commonHolidayRules
  },
  data() {
    return {
      // 公休弹窗visible
      // holidayVisible: false,
      pagina: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false,
      form: {},
      tableData: [{}],
      type: 1, // 1 2 新建 编辑
      visible: 1 // 页面展示逻辑 4公告假期 3 排班
    }
  },
  created() {
    // 获取考勤组列表
    this.handleGetAttendanceSettingList()
  },
  methods: {
    // 新建 编辑 排班
    open(num) {
      this.visible = num || 1
    },
    createGroup() {
      this.open(2)
      this.type = 1
      this.$nextTick(() => {
        this.$refs.edit.init()
      })
    },
    // 获取考勤组列表
    handleGetAttendanceSettingList() {
      this.loading = true
      const msg = {
        ...this.form,
        ...this.pagina
      }
      getAttendanceSettingList(msg)
        .then(res => {
          this.tableData = res.data.result
          this.pagina.total = Number(res.data.count)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 分页相关
    handleSizeChange(val) {
      this.pagina.size = val
      this.handleGetAttendanceSettingList()
    },
    handleCurrentChange(val) {
      this.pagina.page = val
      this.handleGetAttendanceSettingList()
    },
    // 删除考勤组
    handleDelSetting(row) {
      this.$confirm(this.$t('835'), this.$t('836'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        delSetting(row).then(res => {
          this.handleGetAttendanceSettingList()
        })
      })
    },
    // 同意
    async confirmAgree(params) {
      const { data } = await checkSettingRelation({ id: params.id })
      if (!data.check_result) {
        this.$confirm(this.$t('i18n.3a2455530ae94812bfb7c8f22b3f69ff'), this.$t('1726'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        }).then(() => {
          this.type = 2
          this.open(2)
          this.$nextTick(() => {
            this.$refs.edit.init(params)
          })
        })
      } else {
        this.type = 2
        this.open(2)
        this.$nextTick(() => {
          this.$refs.edit.init(params)
        })
      }
    },
    handlerShe(row, num) {
      this.open(num)
      if (num === 3) this.$nextTick(() => this.$refs.scheding.init(row.id))
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .by-content {
    height: calc(100% - 60px);
    overflow: auto;
    .form-wrap {
      margin: 0 0 20px 0;
      position: relative;
      .create-group {
        position: absolute;
        right: 0;
      }
      .create-group-s {
        position: absolute;
        right: 120px;
      }
      .query {
        margin-left: 30px;
      }
    }
  }
  .radio-wrap {
    line-height: 60px;
  }
  .by-list-title {
    line-height: 1;
    height: 18px;
    color: $menuBg;
    font-weight: 600;
  }
}
</style>
